import React from "react";
import { StickyFooterMemberMobile } from "./StickyFooterMemberMobile";
import { StickyFooterMemberDesktop } from "./StickyFooterMemberDesktop";
import { stickyFooterMemberStyle } from "./StickyFooterMember.css";
import { usePathname } from "next/navigation";

const hideOnUrls = ["/account/favourites"];

type Props = { isExperimentalPdp?: boolean };
export const StickyFooterMember: React.FC<Props> = ({
  isExperimentalPdp = false
}) => {
  const pathname = usePathname();

  if (hideOnUrls.some((url) => pathname.includes(url))) {
    return null;
  }

  return (
    <>
      <div
        className={stickyFooterMemberStyle}
        data-testid="NewStickyFooterMember"
      >
        <StickyFooterMemberMobile isExperimentalPdp={isExperimentalPdp} />
        <StickyFooterMemberDesktop />
      </div>
    </>
  );
};
